import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import {
  fetchConsultationIntakeFields,
  fetchConsultationOutcomeOptions,
  replaceConsultationIntakeFields,
  replaceConsultationOutcomeOptions,
} from '@/api/firstConsultations/firstConsultationsApi';
import type {
  IntakeField,
  IntakeFieldDraft,
  OutcomeOption,
  OutcomeOptionDraft,
} from '@/api/firstConsultations/firstConsultationsApi.types';
import {
  CONSULTATION_INTAKE_FIELDS_QUERY_KEY,
  CONSULTATION_OUTCOME_OPTIONS_QUERY_KEY,
} from '@/constants/queryKeys';

export function useConsultationIntakeFieldsQuery(
  isEnabled = true
): UseQueryResult<IntakeField[], Error> {
  return useQuery({
    queryKey: CONSULTATION_INTAKE_FIELDS_QUERY_KEY,
    queryFn: fetchConsultationIntakeFields,
    enabled: isEnabled,
  });
}

export function useReplaceConsultationIntakeFieldsMutation(): UseMutationResult<
  IntakeField[],
  Error,
  IntakeFieldDraft[]
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: replaceConsultationIntakeFields,
    onSuccess: function store(fields) {
      queryClient.setQueryData(CONSULTATION_INTAKE_FIELDS_QUERY_KEY, fields);
    },
  });
}

export function useConsultationOutcomeOptionsQuery(
  isEnabled = true
): UseQueryResult<OutcomeOption[], Error> {
  return useQuery({
    queryKey: CONSULTATION_OUTCOME_OPTIONS_QUERY_KEY,
    queryFn: fetchConsultationOutcomeOptions,
    enabled: isEnabled,
  });
}

export function useReplaceConsultationOutcomeOptionsMutation(): UseMutationResult<
  OutcomeOption[],
  Error,
  OutcomeOptionDraft[]
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: replaceConsultationOutcomeOptions,
    onSuccess: function store(options) {
      queryClient.setQueryData(CONSULTATION_OUTCOME_OPTIONS_QUERY_KEY, options);
    },
  });
}
